import { Box, BoxProps } from "@chakra-ui/react"
import { useUnreadChatNotifications } from "Shared/hooks/useUnreadChatNotifications"
import React from "react"

export const UnreadChatBadge: React.FC<
  {
    moderatedStudyApplicationId: string
  } & BoxProps
> = ({ moderatedStudyApplicationId, ...props }) => {
  const unreadChats = useUnreadChatNotifications()

  const isThisChatUnread = unreadChats.some(
    (chat) =>
      chat.moderated_study_application_id === moderatedStudyApplicationId
  )

  if (!isThisChatUnread) return null

  return (
    <Box
      pos="absolute"
      top={-1}
      right={-1}
      boxSize={3}
      rounded="full"
      bg="ds.icon.accent.red"
      {...props}
    />
  )
}
